import { EFeaturesActionType } from './types';
import { updateFeatureProperties } from './updateFeatureProperies';
import { TFeature, TFeatureWithPrecision } from '../../types/map';
import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { fetchNewbuildingClusters, toggleFeaturesActiveStatus } from '../newbuildingPolygon';

export const setSelectedFeature = actionGenerator<EFeaturesActionType.FeatureSelected, TFeatureWithPrecision>(
  EFeaturesActionType.FeatureSelected,
);

export function selectFeature(feature: TFeature, precision: number): TThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    const {
      activeFeature: selectedFeature,
      activeNewbuildingPolygon: { geohashIds },
      features,
    } = getState();

    dispatch(toggleFeaturesActiveStatus({ geohashIds, isActive: false }));

    // Сбрасываем isActive для всех активных главных пинов ЖК
    if (features[precision]) {
      const activeMainPins = Object.values(features[precision].features).filter(
        f => f.properties.isNewbuildingMainPin && f.properties.isActive,
      );

      activeMainPins.forEach(mainPinFeature => {
        dispatch(
          updateFeatureProperties({
            featureId: mainPinFeature.id,
            precision,
            properties: { isActive: false },
          }),
        );
      });
    }

    // Убирает несериализуемое поле options
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { options, ...serializableFeature } = feature as TFeature & { options?: unknown };
    dispatch(setSelectedFeature({ ...serializableFeature, precision }));

    if (selectedFeature) {
      dispatch(
        updateFeatureProperties({
          featureId: selectedFeature.id,
          precision: selectedFeature.precision,
          properties: { isActive: false },
        }),
      );
    }
    dispatch(updateFeatureProperties({ featureId: feature.id, precision, properties: { isActive: true } }));

    // Если это главный пин ЖК, загружаем кластеры для выделения полигона по аналогии с открытием полигона)
    if (feature.properties.isNewbuildingMainPin && feature.properties.newbuilding) {
      await dispatch(
        fetchNewbuildingClusters(
          feature.properties.newbuilding.id,
          !!feature.properties.newbuilding.isAnyFicheringPlus,
        ),
      );
    }
  };
}
